import React from 'react';
import { useEstimatedTradeCostData } from 'widgets/estimatedTradeCost/widget/hooks';
import { useSymboInfo } from 'symbols/symbolInfo/hooks';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';

export function EstimatedTradeCostTitle() {
    const data = useEstimatedTradeCostData();
    const info = useSymboInfo(
        data?.request.inetSymbol,
        SymbologyValues.Instinet
    );
    if (!info?.description) {
        return <></>;
    }

    return <div className={'widget-title'}>{info.description}</div>;
}
